$(function() {
  
  $('.skate-selector .level-1 .item').click(function(){    
    var level1 = $(this).data('level-1');
    $('.skate-selector').data('data-l1', level1);   
    $('.skate-selector .level-1').hide();
    $('.skate-selector .level-2').fadeIn();
  });
  
  $('.skate-selector .level-2 .item').click(function(){    
    var level2 = $(this).data('level-2');
    $('.skate-selector').data('data-l2', level2);   
    $('.skate-selector .level-2').hide();
    
    var collection = 'collections/selector-' + $('.skate-selector').data('data-l1') + '-' + $('.skate-selector').data('data-l2');
    
    $('.skate-selector .results a').attr('href', collection);
    $('.skate-selector .results').fadeIn();
    
    window.location.href = 'http://' + window.location.hostname + '/' + collection;
    
  });
  
  // product tabs
  $('#tab-container').easytabs();
  
  
});
  
/////////////////////////////////////
//  Mega Menu
/////////////////////////////////////

$(function() {
  if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){ 
    if(jQuery(window).width() >= 320 && jQuery(window).width() <= 1024)
    {
      $('.wsmenu-list > li > a.twin').click(function(e) {
        e.preventDefault();
        if(!$(this).hasClass("ws-activearrow"))
        {
          $(this).toggleClass('ws-activearrow').parent().siblings().children().removeClass('ws-activearrow');
          $(this).prev('.wsmenu-click').toggleClass('ws-activearrow');
          $(".wsmenu-submenu, .megamenu").not($(this).siblings('.wsmenu-submenu, .megamenu')).slideUp('slow');

          if(jQuery(window).width() <= 768){
            $(this).siblings('.wsmenu-submenu').slideToggle('slow');
            $(this).siblings('.megamenu').slideToggle('slow');
          }
        }
        else
        {
          window.location = $(this).attr('href');
          return false;
        }
      });
      $('.wsmenu-sub-list > li > h5').click(function(e) {
        if(jQuery(window).width() <= 768){
          e.preventDefault();
          if(!$(this).hasClass("menu-clicked"))
          {
            $(this).children('.wsmenu-arrow').toggleClass('wsmenu-rotate');
            $(this).siblings('.wsmenu-submenu-sub').slideToggle('slow');
            $(this).siblings('.wsmenu-submenu-sub-sub').slideToggle('slow');
            $(this).siblings('.wsmenu-sub-list ul').slideToggle('slow');
            $(this).prev('.wsmenu-click02').children().toggleClass('wsmenu-rotate');
            $(this).addClass("menu-clicked");
          }
          else
          {
            window.location = $(this).children('a').attr('href');
            return false;
          }
        }
      });
      $('.wsmenu-list > li > .megamenu > ul > li > ul > li > a').click(function(e) {
        if($(this).next().hasClass("level") && jQuery(window).width() <= 768)
        {              
          if(!$(this).hasClass("menu-clicked"))
          {
            e.preventDefault();
            $(this).children('.wsmenu-arrow').toggleClass('wsmenu-rotate');
            $(this).siblings('.wsmenu-sub-list ul').slideToggle('slow');
            $(this).prev('.wsmenu-click02').children().toggleClass('wsmenu-rotate');
            $(this).addClass("menu-clicked");
          }
          else
          {
            window.location = $(this).children('a').attr('href');
            return false;
          }

        }
      });
      $('.has-submenu > a').click(function(e) {
        e.preventDefault();
        e.preventDefault();
        if(!$(this).hasClass("menu-clicked"))
        {
          if(jQuery(window).width() <= 768){
            $(this).next('.wsmenu-submenu').slideToggle('slow');
          }
          $(this).prev('.wsmenu-click').toggleClass('ws-activearrow');
          $(this).addClass("menu-clicked");
        }
        else
        {
          window.location = $(this).attr('href');
          return false;
        }
      });
      $('.has-submenu-sub > a').click(function(e) 
                                      {
        e.preventDefault();
        if(!$(this).hasClass("menu-clicked"))
        {
          if(jQuery(window).width() <= 768){
            $(this).next('.wsmenu-submenu-sub').slideToggle('slow');
          }
          $(this).prev('.wsmenu-click02').children('i').toggleClass('wsmenu-rotate');
          $(this).addClass("menu-clicked");
        }
        else
        {
          window.location = $(this).attr('href');
          return false;
        }
      });
      $('.has-submenu-sub-sub > a').click(function(e) {
        if(!$(this).hasClass("menu-clicked"))
        {
          e.preventDefault();
          if(jQuery(window).width() <= 768){
            $(this).next('.wsmenu-submenu-sub-sub').slideToggle('slow');
          }
          $(this).prev('.wsmenu-click02').children('i').toggleClass('wsmenu-rotate');
          $(this).addClass("menu-clicked");
        }
        else
        {
          window.location = $(this).attr('href');
          return false;
        } 
      });
      $(window).on("touchend",function() {
        $("li").removeClass('hover');
      });
      $('.mega_menu > li').on("touchend",function(event){
        event.stopPropagation();
        $(this).siblings().removeClass('hover');
        $(this).addClass('hover');
      });
      $('.multi-drop > .wsmenu-list > li').on("touchend",function(event){
        event.stopPropagation();
        $(this).siblings().removeClass('hover');
        $(this).addClass('hover');
      });
      $('.multi-drop > .wsmenu-list > li > ul > li').on("touchend",function(event){
        event.stopPropagation();
        $(this).siblings().removeClass('hover');
        $(this).addClass('hover');
      });
      $('.multi-drop > .wsmenu-list > li > ul > li > ul > li').on("touchend",function(event){
        event.stopPropagation();
        $(this).siblings().removeClass('hover');
        $(this).addClass('hover');
      });
    }
    else
    {

      $('.mega_menu > li').hoverIntent(function() {
        $(this).addClass('hover');
      }, function() {
        $(this).removeClass('hover');
      });
      $('.multi-drop > .wsmenu-list > li').hoverIntent(function() {
        $(this).addClass('hover');
      }, function() {
        $(this).removeClass('hover');
        $(this).find("li").removeClass('hover');
      });
      $('.multi-drop > .wsmenu-list > li > ul > li').hover(function() {
        $(this).addClass('hover');
      }, function() {
        $(this).removeClass('hover');
        $(this).find("li").removeClass('hover');
      });
      $('.multi-drop > .wsmenu-list > li > ul > li > ul > li').hover(function() {
        $(this).addClass('hover');
      }, function() {
        $(this).removeClass('hover');
        $(this).find("li").removeClass('hover');
      });
    }
  }
  else
  {

    $('.mega_menu > li').hoverIntent(function() {
      $(this).addClass('hover');
    }, function() {
      $(this).removeClass('hover');
    });
    $('.multi-drop > .wsmenu-list > li').hoverIntent(function() {
      $(this).addClass('hover');
    }, function() {
      $(this).removeClass('hover');
      $(this).find("li").removeClass('hover');
    });
    $('.multi-drop > .wsmenu-list > li > ul > li').hover(function() {
      $(this).addClass('hover');
    }, function() {
      $(this).removeClass('hover');
      $(this).find("li").removeClass('hover');
    });
    $('.multi-drop > .wsmenu-list > li > ul > li > ul > li').hover(function() {
      $(this).addClass('hover');
    }, function() {
      $(this).removeClass('hover');
      $(this).find("li").removeClass('hover');
    });
  }

  $('#wsnavtoggle').click(function() {
    $('.wsmenucontainer').toggleClass('wsoffcanvasopener');
  });
  $('.overlapblackbg').click(function() {
    $('.wsmenucontainer').removeClass('wsoffcanvasopener');
  });
  $('.wsmenu-list> li').has('.wsmenu-submenu').prepend('<span class="wsmenu-click"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
  $('.wsmenu-list > li').has('.megamenu').prepend('<span class="wsmenu-click"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
  $('.wsmenu-click').click(function() {
    $(this).toggleClass('ws-activearrow').parent().siblings().children().removeClass('ws-activearrow');
    $(".wsmenu-submenu, .megamenu").not($(this).siblings('.wsmenu-submenu, .megamenu')).slideUp('slow');
    $(this).siblings('.wsmenu-submenu').slideToggle('slow');
    $(this).siblings('.megamenu').slideToggle('slow');
  });
  $('.wsmenu-list > li > ul > li').has('.wsmenu-submenu-sub').prepend('<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
  $('.wsmenu-list > li > ul > li > ul > li').has('.wsmenu-submenu-sub-sub').prepend('<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
  $('.wsmenu-click02').click(function() {
    $(this).children('.wsmenu-arrow').toggleClass('wsmenu-rotate');
    $(this).siblings('.wsmenu-submenu-sub').slideToggle('slow');
    $(this).siblings('.wsmenu-submenu-sub-sub').slideToggle('slow');
  });
});
$(function() {
  $('.wsmenu-sub-list > li').prepend('<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
  $('.wsmenu-sub-list > li > ul > li').has('.level').prepend('<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
  $('.wsmenu-click02').click(function() {
    $(this).children('.wsmenu-arrow').toggleClass('wsmenu-rotate');
    $(this).siblings('.wsmenu-sub-list ul').slideToggle('slow');
  });
  $(window).resize(function() {
    if ($(window).width() > 768) {
      $('.wsmenu-sub-list ul').slideDown();
    }
  });
});
(function($) {
  $.fn.hoverIntent = function(handlerIn, handlerOut, selector) {
    var cfg = {
      interval: 100,
      sensitivity: 6,
      timeout: 300
    };
    if (typeof handlerIn === "object") {
      cfg = $.extend(cfg, handlerIn)
    } else {
      if ($.isFunction(handlerOut)) {
        cfg = $.extend(cfg, {
          over: handlerIn,
          out: handlerOut,
          selector: selector
        })
      } else {
        cfg = $.extend(cfg, {
          over: handlerIn,
          out: handlerIn,
          selector: handlerOut
        })
      }
    }
    var cX, cY, pX, pY;
    var track = function(ev) {
      cX = ev.pageX;
      cY = ev.pageY
    };
    var compare = function(ev, ob) {
      ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
      if (Math.sqrt((pX - cX) * (pX - cX) + (pY - cY) * (pY - cY)) < cfg.sensitivity) {
        $(ob).off("mousemove.hoverIntent", track);
        ob.hoverIntent_s = true;
        return cfg.over.apply(ob, [ev])
      } else {
        pX = cX;
        pY = cY;
        ob.hoverIntent_t = setTimeout(function() {
          compare(ev, ob)
        }, cfg.interval)
      }
    };
    var delay = function(ev, ob) {
      ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
      ob.hoverIntent_s = false;
      return cfg.out.apply(ob, [ev])
    };
    var handleHover = function(e) {
      var ev = $.extend({}, e);
      var ob = this;
      if (ob.hoverIntent_t) {
        ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t)
      }
      if (e.type === "mouseenter") {
        pX = ev.pageX;
        pY = ev.pageY;
        $(ob).on("mousemove.hoverIntent", track);
        if (!ob.hoverIntent_s) {
          ob.hoverIntent_t = setTimeout(function() {
            compare(ev, ob)
          }, cfg.interval)
        }
      } else {
        $(ob).off("mousemove.hoverIntent", track);
        if (ob.hoverIntent_s) {
          ob.hoverIntent_t = setTimeout(function() {
            delay(ev, ob)
          }, cfg.timeout)
        }
      }
    };
    return this.on({
      "mouseenter.hoverIntent": handleHover,
      "mouseleave.hoverIntent": handleHover
    }, cfg.selector)
  }
})(jQuery);

/* stiky menu */


/*for overflow of the menu*/
$(function () 
  {
  $(".multi-drop li").each(function (e) {
    if ($('ul', this).length) 
    {
      var elm = $('ul:first', this);
      var off = elm.offset();
      var l = off.left;
      var w = elm.width();
      var docH = $(window).height();
      var docW = $(window).width()-2;
      var isEntirelyVisible = (l + w <= docW);
      if (!isEntirelyVisible) 
      {
        $(this).addClass('edge');
      } else {
        $(this).removeClass('edge');}}
  });
  $( window ).resize(function() {
    $(".multi-drop li").each(function (e) {
      if ($('ul', this).length) 
      {
        $(this).removeClass('edge');
        var elm = $('ul:first', this);
        var off = elm.offset();
        var l = off.left;
        var w = elm.width();
        var docH = $(window).height();
        var docW = $(window).width()-2;
        var isEntirelyVisible = (l + w <= docW);
        if (!isEntirelyVisible && docW > 767 )
        {
          console.log(this);
          $(this).addClass('edge');
        } else {
          $(this).removeClass('edge');
        }}
    });
  });

});

$(function () 
  {
  $(".mega_menu > li").each(function (e) {
    if ($('ul', this).length) 
    {
      $(this).children().removeClass('over_left_menu');
      var elm = $('ul:first', this);
      var off = elm.offset();
      var l = off.left;
      var w = elm.width();
      var docH = $(window).height();
      var docW = $(window).width()-2;
      var isEntirelyVisible = (l + w <= docW);
      if (!isEntirelyVisible && docW > 767 )
      {
        $(this).children().addClass('over_left_menu');
      } else {
        $(this).children().removeClass('over_left_menu');
      }}
    $( window ).resize(function() {
      $(".mega_menu > li").each(function (e) {
        if ($('ul', this).length) 
        {
          $(this).children().removeClass('over_left_menu');
          var elm = $('ul:first', this);
          var off = elm.offset();
          var l = off.left;
          var w = elm.width();
          var docH = $(window).height();
          var docW = $(window).width()-2;
          var isEntirelyVisible = (l + w <= docW);
          if (!isEntirelyVisible && docW > 767 )
          {
            $(this).children().addClass('over_left_menu');
          } else {
            $(this).children().removeClass('over_left_menu');
          }}
      }); 
    }); 
  });
  $(".multi-drop .wsmenu-click02").click(function (){ $(this).children(".wsmenu-arrow").toggleClass( "wsmenu-rotate");}) 
});


jQuery("#currencies").change(function()
                             {
  cookieCurrency = $(this).val();
  console.log(cookieCurrency);
});

if(jQuery(window).width() > 991)
{
  var product_grid_height = 0;
  var grid_height;
  var prod_height;
  var total = jQuery('#content .home_product .product_grid').length;    
  jQuery("#content .home_product .product_grid").each(function (e) {
    grid_height = $(this).height();
    if(grid_height > product_grid_height){
      product_grid_height = grid_height;
    }

    if(e == total - 1)
    {
      jQuery("#content .home_product .product_grid").css("height",product_grid_height+"px");
    }
  });
}
else
{
  jQuery("#content .home_product .product_grid").css("height","auto");
}
$( window ).resize(function() {
  if(jQuery(window).width() > 991)
  {
    var product_grid_height = 0;
    var grid_height;
    var total = jQuery('#content .home_product .product_grid').length;    
    jQuery("#content .home_product .product_grid").each(function (e) {
      grid_height = $(this).height();
      if(grid_height > product_grid_height){
        product_grid_height = grid_height;
      }
      if(e == total - 1)
      {
        prod_height = product_grid_height+"px"
        jQuery("#content .home_product .product_grid").css("height",prod_height);
      }
    });
  }
  else
  {
    jQuery("#content .home_product .product_grid").css("height","auto");
  }
});